import { Component, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectCaseRcnResults } from '../../state/case/case.selectors'
import { RecurrentNeighborhoodsResult } from '../../state/case/case.state'
import { Subject, takeUntil } from 'rxjs'
import { environment } from 'src/environments/environment'

@Component({
    selector: 'app-recurrent-neighborhoods-result',
    templateUrl: './recurrent-neighborhoods-result.component.html',
    styleUrls: ['./recurrent-neighborhoods-result.component.scss'],
})
export class RecurrentNeighborhoodsResultComponent implements OnDestroy {
    @ViewChild('dropdownRoot') dropdownRoot?: ElementRef<HTMLElement>

    plotOptions: RecurrentNeighborhoodsResult[] = []
    selectedResults: RecurrentNeighborhoodsResult[] = []
    dropdownOpen = false

    private readonly destroy$ = new Subject<void>()
    private readonly wikiUrl = environment.wikiUrl

    constructor(private store: Store) {
        this.store
            .select(selectCaseRcnResults)
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
                this.plotOptions = [...data].sort((a, b) =>
                    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
                )
                const available = new Set(this.plotOptions.map(r => r.name))
                this.selectedResults = this.selectedResults
                    .filter(r => available.has(r.name))
                    .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
            })
    }

    get selectionLabel(): string {
        if (!this.plotOptions.length) return 'No RCN plots'
        if (!this.selectedResults.length) return 'Select RCN plots'
        if (this.selectedResults.length === 1) return this.selectedResults[0].name
        return `${this.selectedResults.length} plots selected`
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        if (!this.dropdownOpen) return
        const root = this.dropdownRoot?.nativeElement
        if (root && !root.contains(event.target as Node)) {
            this.dropdownOpen = false
        }
    }

    toggleDropdown(event: MouseEvent): void {
        event.stopPropagation()
        if (!this.plotOptions.length) return
        this.dropdownOpen = !this.dropdownOpen
    }

    isSelected(name: string): boolean {
        return this.selectedResults.some(r => r.name === name)
    }

    togglePlot(plot: RecurrentNeighborhoodsResult): void {
        if (this.isSelected(plot.name)) {
            this.selectedResults = this.selectedResults.filter(r => r.name !== plot.name)
        } else {
            this.selectedResults = [...this.selectedResults, plot].sort((a, b) =>
                a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
            )
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    goToWiki(): void {
        window.open(`${this.wikiUrl}home/Navigation#recurrent-spatial-neighborhoods-rcns`, '_blank')
    }
}
